import React from 'react';

const GoalContext = React.createContext({
    goals: [],
    settings: null,
    activeGoal: null,
    activeLocation: null,
    activeMapInstance: {},
    activeMarker: null,
    activeSwiper: null,
    setActiveMarker: (item) => {},
    setActiveLocation: (item) => {},
    setActiveItem: (item) => {},
    setMapInstance: (item) => {},
    setActiveSwiper: (item) => {}
});

export default GoalContext;